export default __webpack_public_path__ + "static/media/timesup.355cfd57.svg";